/* ita-loc.js: the opened country and currency box (snippets/ita-localization, Theme settings > Country box look).
   Open/close, search, Escape, arrows, click outside. The country buttons are real submit buttons of Shopify's localization form. */
(function () {
  if (window.__itaLoc) return; window.__itaLoc = 1;
  var D = document;
  function box(f) { return { f: f, b: f.querySelector(".ita-loc-btn"), p: f.querySelector(".ita-loc-p"), bd: f.querySelector(".ita-loc-bd"), s: f.querySelector(".ita-loc-s"), l: f.querySelector(".ita-loc-l"), e: f.querySelector(".ita-loc-e") }; }
  function close(f, back) {
    var x = box(f); if (!x.p || x.p.hidden) return;
    x.p.hidden = true; x.bd.hidden = true; x.b.setAttribute("aria-expanded", "false"); f.classList.remove("open");
    if (f.classList.contains("ita-loc-pop")) reset(f);
    if (!D.querySelector(".ita-loc.open")) D.documentElement.classList.remove("ita-loc-lock");
    if (back) x.b.focus({ preventScroll: true });
  }
  /* The country list is printed once as JSON (#ita-loc-data, snippets/ita-localization); each selector gets its rows the first time it opens. */
  var DATA = null;
  function data() {
    if (DATA) return DATA;
    var n = D.getElementById("ita-loc-data"); try { DATA = n ? JSON.parse(n.textContent) : []; } catch (e) { DATA = []; }
    return DATA;
  }
  function esc(v) { return String(v == null ? "" : v).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }
  /* Phone popover (option A): put the main countries (setting country_tiles) first, then the current country if it is not one of them;
     the rest follow. Only those rows show until "All countries" is pressed or something is typed. */
  function reset(f) {
    var x = box(f), ar = f.querySelector(".ita-loc-ar");
    x.p.classList.remove("all", "q"); if (ar) ar.setAttribute("aria-expanded", "false");
    if (x.s) x.s.value = "";
    if (x.l) { x.l.scrollTop = 0; x.l.querySelectorAll("li[hidden]").forEach(function (li) { li.hidden = false; }); }
    if (x.e) x.e.hidden = true;
  }
  function place(f) {
    var x = box(f), cr = x.b.getBoundingClientRect(), fr = f.getBoundingClientRect(), W = D.documentElement.clientWidth;
    var w = Math.min(300, W - 16), l = Math.max(8, Math.min(cr.left - 2, W - w - 8));
    x.p.style.width = w + "px"; x.p.style.left = (l - fr.left) + "px"; x.p.style.top = (cr.bottom - fr.top + 9) + "px";
    x.p.style.setProperty("--cx", (cr.left + cr.width / 2 - l - 6) + "px"); x.p.style.setProperty("--ox", (cr.left + cr.width / 2 - l) + "px");
    var bar = f.closest("header, .ita-ann"); x.bd.style.top = Math.max(0, (bar ? bar.getBoundingClientRect().bottom : cr.bottom + 8)) + "px";
  }
  function fill(f) {
    var l = f.querySelector(".ita-loc-l"); if (!l || l.getAttribute("data-built")) return;
    var cur = l.getAttribute("data-cur") || "", h = "", pop = f.classList.contains("ita-loc-pop"), list = data(), topn = 0;
    if (pop) {
      var top = [];
      (l.getAttribute("data-tiles") || "").split(",").forEach(function (v) {
        var iso = v.trim().toUpperCase(), c = list.filter(function (z) { return z.i === iso; })[0]; if (c && top.indexOf(c) < 0) top.push(c);
      });
      var cc = list.filter(function (z) { return z.i === cur; })[0]; if (cc && top.indexOf(cc) < 0) top.push(cc);
      topn = top.length; list = top.concat(list.filter(function (z) { return top.indexOf(z) < 0; }));
    }
    var ord = (l.getAttribute("data-order") || "").split(",").map(function (v) { return v.trim().toUpperCase(); }).filter(Boolean);
    if (ord.length) {
      var head = list.slice(0, topn), rest = list.slice(topn), pri = [];
      ord.forEach(function (iso) { var c = rest.filter(function (z) { return z.i === iso; })[0]; if (c) pri.push(c); });
      list = head.concat(pri, rest.filter(function (z) { return pri.indexOf(z) < 0; }));
    }
    list.forEach(function (c, k) {
      var on = c.i === cur;
      h += '<li' + (pop && k < topn ? ' data-top="1"' : "") + ' data-q="' + esc((c.n + " " + c.i + " " + c.c).toLowerCase()) + '"><button type="submit" name="country_code" value="' + esc(c.i) + '" class="ita-loc-o' + (on ? " on" : "") + '"' + (on ? ' aria-current="true"' : "") + '>' +
        '<span class="ita-loc-f" aria-hidden="true"><img src="' + esc(c.f) + '" alt="" loading="lazy" width="20" height="15"></span>' +
        '<span class="ita-loc-n">' + esc(c.n) + '</span><span class="ita-loc-c">' + esc(c.c) + " " + esc(c.y) + '</span><span class="ita-loc-k" aria-hidden="true"></span></button></li>';
    });
    l.innerHTML = h; l.setAttribute("data-built", "1");
    var tl = f.querySelector(".ita-loc-tl"), all = data();
    var n = f.querySelector("[data-loc-n]"); if (n) n.textContent = n.hasAttribute("data-plain") ? String(all.length) : "(" + all.length + ")";
    if (tl && !tl.getAttribute("data-built")) {
      var want = (tl.getAttribute("data-tiles") || "").split(",").map(function (v) { return v.trim().toUpperCase(); }).filter(Boolean), t = "";
      want.forEach(function (iso) {
        var c = all.filter(function (x) { return x.i === iso; })[0]; if (!c) return;
        var on = c.i === cur;
        t += '<button type="submit" name="country_code" value="' + esc(c.i) + '" class="ita-loc-tile' + (on ? " on" : "") + '"' + (on ? ' aria-current="true"' : "") + ' aria-label="' + esc(c.n + ", " + c.c) + '">' +
          '<img src="' + esc(c.f) + '" alt="" width="28" height="21"><b>' + esc(c.c) + '</b></button>';
      });
      tl.innerHTML = t; tl.setAttribute("data-built", "1");
    }
  }
  function open(f) {
    D.querySelectorAll(".ita-loc.open").forEach(function (o) { if (o !== f) close(o); });
    fill(f);
    var x = box(f); x.p.hidden = false; x.bd.hidden = false; x.b.setAttribute("aria-expanded", "true"); f.classList.add("open");
    D.documentElement.classList.add("ita-loc-lock");
    if (f.classList.contains("ita-loc-pop")) { place(f); f.__sy = window.pageYOffset; }
    else { var cur = x.l.querySelector(".on"); if (cur) x.l.scrollTop = Math.max(0, cur.parentNode.offsetTop - 56); }
    if (x.s && window.matchMedia("(hover:hover)").matches) x.s.focus({ preventScroll: true });
  }
  D.addEventListener("click", function (e) {
    var t = e.target, b = t.closest && t.closest(".ita-loc-btn");
    if (b) { var f = b.closest(".ita-loc"); if (f.classList.contains("open")) close(f); else open(f); return; }
    var ar = t.closest && t.closest(".ita-loc-ar");
    if (ar) { var pf = ar.closest(".ita-loc"), px = box(pf), on = !px.p.classList.contains("all"); px.p.classList.toggle("all", on); ar.setAttribute("aria-expanded", on ? "true" : "false"); if (px.l) px.l.scrollTop = 0; return; }
    var x = t.closest && t.closest(".ita-loc-x"); if (x) { close(x.closest(".ita-loc"), true); return; }
    if (t.classList && t.classList.contains("ita-loc-bd")) { close(t.closest(".ita-loc"), true); return; }
    if (!(t.closest && t.closest(".ita-loc-p"))) D.querySelectorAll(".ita-loc.open").forEach(function (o) { close(o); });
  });
  D.addEventListener("input", function (e) {
    if (!e.target.classList || !e.target.classList.contains("ita-loc-s")) return;
    var x = box(e.target.closest(".ita-loc")), q = e.target.value.trim().toLowerCase(), n = 0;
    x.p.classList.toggle("q", !!q);
    x.l.querySelectorAll("li").forEach(function (li) { var ok = !q || li.getAttribute("data-q").indexOf(q) > -1; li.hidden = !ok; if (ok) n++; });
    if (x.e) x.e.hidden = n > 0;
  });
  /* phone popover: closes when focus leaves it, on page scroll, and on rotate/resize */
  D.addEventListener("focusin", function (e) {
    D.querySelectorAll(".ita-loc-pop.open").forEach(function (o) { if (!o.contains(e.target)) close(o); });
  });
  window.addEventListener("scroll", function () {
    D.querySelectorAll(".ita-loc-pop.open").forEach(function (o) { if (Math.abs(window.pageYOffset - (o.__sy || 0)) > 40) close(o); });
  }, { passive: true });
  window.addEventListener("resize", function () {
    D.querySelectorAll(".ita-loc-pop.open").forEach(function (o) { place(o); });
  });
  D.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { D.querySelectorAll(".ita-loc.open").forEach(function (o) { close(o, true); }); return; }
    var f = e.target.closest && e.target.closest(".ita-loc.open");
    if (!f || (e.key !== "ArrowDown" && e.key !== "ArrowUp")) return;
    var items = [].slice.call(f.querySelectorAll(".ita-loc-l li:not([hidden]) .ita-loc-o")).filter(function (b) { return b.offsetParent !== null; }); if (!items.length) return;
    var i = items.indexOf(D.activeElement); e.preventDefault();
    i = e.key === "ArrowDown" ? Math.min(items.length - 1, i + 1) : Math.max(0, i - 1); items[i].focus();
  });
  /* Switching country (or language) stays on the SAME page: return_to = current path + query (the test switch ?country= is dropped so
     it cannot undo the new pick), the cart is kept by Shopify, and a second submit while the first is going is ignored. */
  D.addEventListener("submit", function (e) {
    var f = e.target; if (!f || !f.classList || !f.classList.contains("ita-loc")) return;
    if (f.__busy) { e.preventDefault(); return; }
    f.__busy = 1; f.classList.add("busy"); f.setAttribute("aria-busy", "true");
    var r = f.querySelector('input[name="return_to"]');
    if (!r) { r = D.createElement("input"); r.type = "hidden"; r.name = "return_to"; f.appendChild(r); }
    var q = location.search.replace(/^\?/, "").split("&").filter(function (v) { return v && !/^country=/i.test(v); }).join("&");
    r.value = location.pathname + (q ? "?" + q : "");
  });
  /* back/forward cache: the page comes back with the form still marked busy */
  window.addEventListener("pageshow", function (e) {
    if (!e.persisted) return;
    D.querySelectorAll(".ita-loc.busy").forEach(function (f) { f.__busy = 0; f.classList.remove("busy"); f.removeAttribute("aria-busy"); });
  });
})();
